var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{staticClass:"report-data-overview"},[_c('googleorsocial',{attrs:{"googleorsocial":_vm.googleadvertising}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{attrs:{"slot":"bottom-name"},slot:"bottom-name"},[_vm._v("相比"+_vm._s(_vm.dataPeriod))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }